import { useEffect, useState } from "react";
import { ArrowRight, Phone } from "lucide-react";

const SHOW_AFTER_SCROLL_PX = 600;

const StickyMobileCTA = ({ scrollToSection }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const bookingEl = document.getElementById("booking");
      const inView =
        bookingEl &&
        bookingEl.getBoundingClientRect().top < window.innerHeight &&
        bookingEl.getBoundingClientRect().bottom > 0;
      setVisible(window.scrollY > SHOW_AFTER_SCROLL_PX && !inView);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      data-testid="sticky-mobile-cta"
      className={`md:hidden fixed bottom-0 left-0 right-0 z-40 px-3 pb-3 pt-2 bg-gradient-to-t from-[#0a0318] via-[#0a0318]/95 to-transparent transition-all duration-300 ${
        visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0 pointer-events-none"
      }`}
    >
      <div className="flex gap-2">
        <button
          type="button"
          onClick={() => scrollToSection("booking")}
          data-testid="sticky-cta-book-now"
          className="flex-1 flex items-center justify-center gap-1.5 bg-gradient-to-r from-amber-600 to-amber-500 hover:from-amber-700 hover:to-amber-600 text-white font-bold py-3 rounded-xl shadow-lg shadow-amber-500/30 text-sm"
        >
          Book Now <ArrowRight className="w-4 h-4" />
        </button>
        <a
          href="tel:8443423626"
          data-testid="sticky-cta-call"
          className="flex items-center justify-center gap-1.5 border border-amber-500/60 text-amber-300 font-semibold px-4 py-3 rounded-xl text-sm bg-[#110422]/80 backdrop-blur"
        >
          <Phone className="w-4 h-4" />
          Call
        </a>
      </div>
    </div>
  );
};

export default StickyMobileCTA;
